var React = require('react');

function CircuitCornerBL (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(72 70) rotate(180)"},[React.createElement("path",{"d":"M0,0H20L50,30V50","transform":"translate(0 20)","fill":"none","stroke":"#eace00","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M0,0H30L70,40V70","fill":"none","stroke":"#eace00","strokeWidth":"4","key":1})]));
}

CircuitCornerBL.defaultProps = {"width":"72","height":"72","viewBox":"0 0 72 72"};

module.exports = CircuitCornerBL;

CircuitCornerBL.default = CircuitCornerBL;
